import React from 'react';
import { motion } from 'framer-motion';
import { CircleCheckIcon, CircleSlashIcon, UserIcon } from 'lucide-react';
import { forkPaths, forkStart } from '../../data/site';
export function ForkDiagram() {
  return <figure className="rounded-2xl border border-mist bg-white/70 p-5 lg:p-7" data-id="element-178" data-mp="3nzoru197t6a6">
      <motion.div initial={{
      opacity: 0,
      y: -6
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.4
    }} className="mx-auto flex max-w-sm items-center justify-center gap-2.5 rounded-xl border border-ink/15 bg-bone px-4 py-3 text-center text-[13px] font-medium text-ink" data-id="element-179" data-mp="3s21u2for6m27">
        <UserIcon className="h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-180" data-mp="34awe80itbtrw" />
        {forkStart}
      </motion.div>

      {/* Fork connector */}
      <svg viewBox="0 0 200 32" className="mt-1 hidden h-8 w-full text-mist sm:block" fill="none" aria-hidden="true" preserveAspectRatio="none" data-id="element-181" data-mp="398y00t7mi772">
        <motion.path d="M100 0 V10 Q100 16 88 16 H54 Q42 16 42 22 V32" stroke="currentColor" strokeWidth="1.5" initial={{
        pathLength: 0
      }} animate={{
        pathLength: 1
      }} transition={{
        duration: 0.5,
        delay: 0.25
      }} data-id="element-182" data-mp="ok0flnos6d32" />
        <motion.path d="M100 0 V10 Q100 16 112 16 H146 Q158 16 158 22 V32" stroke="currentColor" strokeWidth="1.5" initial={{
        pathLength: 0
      }} animate={{
        pathLength: 1
      }} transition={{
        duration: 0.5,
        delay: 0.25
      }} data-id="element-183" data-mp="r2gjvhqlegdb" />
      </svg>

      <div className="mt-4 grid gap-4 sm:mt-0 sm:grid-cols-2" data-id="element-184" data-mp="i3v57xo8rlht">
        {forkPaths.map((path, pathIndex) => {
        const dead = path.tone === 'dead';
        return <motion.ol key={path.title} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.45,
          delay: 0.5 + pathIndex * 0.12
        }} className="flex flex-col gap-2" data-id="element-185" data-mp="8d0hspz9efus" data-mpi={pathIndex}>
              <li className={`rounded-lg px-3 py-2 text-center font-mono text-[10px] uppercase tracking-[0.14em] ${dead ? 'bg-clay/10 text-clay' : 'bg-teal/10 text-teal'}`} data-id="element-186" data-mp="3qh257ndpf74i">
                {path.title}
              </li>
              {path.nodes.map((node, i) => {
            const terminal = i === path.nodes.length - 1;
            return <li key={node} className={['flex flex-1 items-center gap-2 rounded-xl border px-3 py-3 text-[13px] leading-snug', terminal && dead ? 'border-clay/40 bg-clay/5 font-semibold text-clay' : terminal ? 'border-teal/40 bg-teal/5 font-semibold text-teal' : 'border-mist bg-bone text-ink'].join(' ')} data-id="element-187" data-mp="36x3h283w0mbc" data-mpi={i}>
                    {terminal ? dead ? <CircleSlashIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-188" data-mp="7ihobheg4ta4" /> : <CircleCheckIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-189" data-mp="3pu4qq68dzalm" /> : null}
                    {node}
                  </li>;
          })}
            </motion.ol>;
      })}
      </div>
    </figure>;
}